import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import DownloadFilesTable from 'components/common/download-files/DownloadFilesTable';
import TableInfoBar from 'components/common/download-files/TableInfoBar';
import { ActionModal, HEADER_SPACING_PRESETS } from '@insurancemenu/imenu-components-lib';
import { useDownloadIMQsPageStore } from 'store/pages/quote/download-imqs/pageStore';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { RouteV2Id } from 'routes/routesConfigV2';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import ZipFileSection from 'components/common/download-files/ZipFileSection';
import { DateStyled, SelectStyled, TableInfoBarStyled, ZipTitleSectionStyled } from './styles';

export const PageContent: React.FC = observer(() => {
  const {
    policyPdfs,
    finalZip,
    warningModalDelegate,
    creationDate,
    flowDelegate,
    carrierOptions,
    selectedCarrier,
    getInitialData,
    setSelectedCarrier,
    downloadPdfFile,
    downloadFinalZip,
  } = useDownloadIMQsPageStore();

  const isPageLoading = flowDelegate.isInitialDataLoading;
  const showCreationDate = !isPageLoading && Boolean(creationDate);

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={RouteV2Id.DOWNLOAD_IMQS}
      pageHeader={{
        subtitleMaxWidth: '42rem',
        spacing: carrierOptions.length > 0 ? { bottom: '4rem' } : HEADER_SPACING_PRESETS.withTopSection,
      }}
      isPageLoading={isPageLoading}
      pageFooter={null}
    >
      {carrierOptions.length > 0 && (
        <SelectStyled
          label="Carrier"
          name="carrier"
          options={carrierOptions}
          value={selectedCarrier}
          width="30rem"
          onChange={(e): void => setSelectedCarrier(e.target.value)}
        />
      )}

      <ZipTitleSectionStyled>
        <TableInfoBarStyled title="Final ZIP" />
        {showCreationDate && <DateStyled>{`Generated on: ${normDateToShortAmericanDate(creationDate)}`}</DateStyled>}
      </ZipTitleSectionStyled>
      <ZipFileSection file={finalZip} onDownload={downloadFinalZip} loading={isPageLoading} />

      <TableInfoBar title="Files" totalFiles={policyPdfs.length} />
      <DownloadFilesTable loading={isPageLoading} filesList={policyPdfs} onDownload={downloadPdfFile} />
      <ActionModal
        show={warningModalDelegate.isVisible}
        onClose={warningModalDelegate.close}
        title={
          <span>
            IMQ files are currently being generated.
            <br /> Please check back in a minute.
          </span>
        }
        modalType={ModalType.NOTIFICATION}
      />
    </QuoteFlowLayout>
  );
});
